








import Vue from "vue";

export default Vue.extend({
  name: "ChallengeVoiceGuidance",
  components: {},
  props: {
    step: {
      type: String,
      default: () => 0
    },
    lang: {
      type: String,
      default: ""
    }
  },
  computed: {
    voiceUrl(): string {
      if (!this.step) return "";
      const langSuffix = this.lang === "vi" ? "_in_vi" : "";
      return `/audio/${this.step}${langSuffix}.mp3`;
    }
  }
});
